import { Injectable } from '@angular/core';
import { addClass, removeClass } from '@utils/dom/class';
import { HighlightMeActorDirective, HighlightMeSceneDirective } from '../directives';

@Injectable({ providedIn: 'root' })
export class HighlightMeController {

  readonly #scenes = new Set<HighlightMeSceneDirective>();

  constructor() { }

  connect(directive: HighlightMeSceneDirective) {
    this.#scenes.add(directive);
  }

  disconnect(directive: HighlightMeSceneDirective) {
    this.#scenes.delete(directive);
  }

  focus(actor: HighlightMeActorDirective) {
    this.highlight(actor, true);
  }

  blur(actor: HighlightMeActorDirective) {
    this.highlight(actor, false);
  }

  highlightActor(actorId: string, on: boolean) {
    [...this.#scenes.values()].forEach(scene => {
      const targetDataSet = `[data-actor-id="${actorId}"]`;
      const elements = scene.domElement.querySelectorAll(`${targetDataSet}`);
      const method = on ? addClass : removeClass;

      Array.from(elements).forEach((element: HTMLElement) => method(element, 'highlight-me'));
    });
  }

  private highlight(actor: HighlightMeActorDirective, on: boolean) {
    const actorId = actor.domElement.dataset['actorId'];
    const method = on ? addClass : removeClass;
    const bgColorCssVar = typeof actor === 'string'
      ? undefined
      : getComputedStyle(actor.domElement).getPropertyValue('--list-container-color');

    [...this.#scenes.values()].forEach(scene => {
      const alias = scene.alias;
      const targetDataSet = `[data-${alias}-${scene.identity}="${actorId}"]`;
      const elements = scene.domElement.querySelectorAll(`${targetDataSet}`);

      Array.from(elements).forEach((element: HTMLElement) => {
        element.style.setProperty('--highlight-me-bg', bgColorCssVar);
        method(element, 'highlight-me');
      });
    });
  }
}
